<template>
  <h1>{{ t("justopp.payments.pageTitle") }}</h1>
</template>

<script>
export default {
  name: "Payments",
  layout: {
    component: "UserDashboardInner",
    params: {
      title: "justopp.payments.pageTitle",
      subTitle: "justopp.payments.pageSubtitle",
      backButton: true,
    },
  },
  middleware: {
    requireUser: {},
    requireNotVendor: {},
  },
};
</script>

<style></style>
